import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from "@react-pdf/renderer";
import Graphs from "./Tables/Graphs";

const styles = StyleSheet.create({
  page: {
    position: "relative",
    flexDirection: "row",
    flexWrap: "wrap",  // ✅ allows two columns to wrap
    paddingTop: 10,
    paddingRight: 20,
    paddingLeft: 20,
    paddingBottom: 20,
  },
  logo: {
    position: "absolute",
    top: 5,      // distance from top
    right: 20,    // distance from right edge
    width: 50,
    height: 30,
  },
  description: {
    width: "100%",
    fontSize: 8,
    marginBottom: 12,
    marginTop: 30,
    paddingHorizontal: 20,
    lineHeight: 1.5,
  },  
  chartWrapper: {
    width: "45%",      // ✅ two per row (with a little spacing)
    marginBottom: 5, 
  },
  chart: {
    width: "100%",
    objectFit: "contain",
  },
});

export const Pdf = ({ chartImage, description }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* ✅ Description text at the top */}
      <View style={{ width: "100%" }}>
        <Image src="/fsa_logo.png" style={styles.logo} />
        <Text style={styles.description}>{description}</Text>
      </View>

      {/* ✅ Charts below */}
      {chartImage.map((img, i) => (
        <View key={i} style={styles.chartWrapper}>
          <Image src={img} style={styles.chart} />
        </View>
      ))}
    </Page>
  </Document>
);

export function DownloadInvoiceButton({ chartImage, description }) {

  const allImagesReady = chartImage && chartImage.length > 0 && chartImage.every(img => img);

  return (
<button
  disabled={!allImagesReady}
  style={{
    padding: "8px 16px",
    marginLeft: 10,
    background: allImagesReady ? "#464f62" : "#999",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    cursor: allImagesReady ? "pointer" : "not-allowed",
  }}
>
  {allImagesReady ? (
    <PDFDownloadLink
      document={<Pdf chartImage={chartImage} description={description} />}
      fileName="Summary.pdf"
      style={{ color: "#fff", textDecoration: "none" }}
    >
      Download PDF
    </PDFDownloadLink>
  ) : (
    "Preparing..."
  )}
</button>

  );
}